// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const reelsCommentsHistoryConfig = {
    title: 'chart.instagram.reels_comments_history',
    id: 'reels_comments_history',
    margin: { left: -25, right: 25 },
    name: {
        date: 'date',
        value: 'chart.instagram.reels_comments_history_name',
        avg: 'chart.instagram.reels_comments_history_avg'
    },
    tooltipTranslation: {
        token: 'chart.instagram.tooltip_history',
        values: ['date', 'value', 'percentage_evolution']
    },
    social: INSTAGRAM,
    color: {
        value: 'yellow',
        avg: 'gray'
    },
    valueFormat: classicFormatMaxTwoDigits,
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
